const errors = state => state.errors;
const errorsNotAcceptable = state => state.errorsNotAcceptable;
const existError = state => state.existError;
const show = state => state.show;
const alert = state => state.alert;

export default {
  errors,
  errorsNotAcceptable,
  existError,
  show,
  alert
};
